import axios from 'axios';
import {CustomerApiEndpoint, ListingApiEndpoint} from '@/beepallet.consts';
import Session from 'supertokens-web-js/recipe/session';
import {CustomerProfile, CustomerProfileCertification, PublicCustomerProfile} from "@/models/backend/CustomerModels";
import {LocalStorageService} from "@/services/backend/LocalStorageService";
import {ref} from "vue";


const apiClient = axios.create({
    baseURL: CustomerApiEndpoint + '/api',
    headers: {
        'Content-Type': 'application/json',
    },
});

export const CustomerProfileService = {
    async getCustomerProfile(customerId: string, refresh : boolean = false): Promise<CustomerProfile | null> {

        const localStorageKey = `customer_profile_${customerId}`;
        const cachedProfile = LocalStorageService.getItem<CustomerProfile>(localStorageKey);

        if (cachedProfile && !refresh) {

            return cachedProfile;
        }

        await Session.attemptRefreshingSession();
        const response = await apiClient.get(`/customer_profile/${customerId}`);
        if(response.status !== 200) {
            return null;
        }
        const customerProfile = response.data;
        if(response.data == "" || response.data == null) {
            return null;
        }

        if(customerProfile.name.length > 0) {
            LocalStorageService.saveItem(localStorageKey, customerProfile);
        }

        return customerProfile;
    },


    async saveCustomerProfile(request : CustomerProfile) : Promise<boolean> {
        await Session.attemptRefreshingSession();
        const response = await apiClient.post('/customer', request);
        if(response.status == 200 || response.status == 202) {
            await this.getCustomerProfile(request.userId, true);
            return true;
        }
        return false;
    },

    async getCertifications() : Promise<CustomerProfileCertification[]> {
        await Session.attemptRefreshingSession();
        const response = await apiClient.get('/customer/certification');
        if(response.status == 200 || response.status == 202) {
           return  response.data.map((certification: any) => {
               return {
                   ...certification,
                   expirationDate: (certification.expirationDate) ? new Date(certification.expirationDate).toISOString().split('T')[0] : ''
               }
           });
        }
        return [];
    },

    async saveCertification(certification : CustomerProfileCertification) : Promise<boolean> {
        await Session.attemptRefreshingSession();
        const response = await apiClient.post('/customer/certification', certification);
        if(response.status == 200 || response.status == 202) {
            return true;
        }
        return false;
    },

    async deleteCertification(certificationType: string) : Promise<boolean> {
        await Session.attemptRefreshingSession();
        const response = await apiClient.delete('/customer/certification/' + encodeURIComponent(certificationType) );
        if(response.status == 200 || response.status == 202) {
            return true;
        }
        return false;
    },


    async getPublicCustomerProfile(customerId: string): Promise<PublicCustomerProfile | null> {
        await Session.attemptRefreshingSession();
        const response = await apiClient.get(`/customer_profile/public/${customerId}`);
        if (response.status === 200) {
            return response.data;
        }
        return null;
    }



};